import Icon from '../components/Icon.vue'

Icon.register({
  'yen-sign': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M351.2 32c9.1 0 14.9 9.7 10.6 17.6l-80.1 150.4h58.3c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12h-88.2l-19.8 37.2v26.8h108c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12h-108v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-108c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h108v-26.8l-19.8-37.2h-88.2c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h58.3l-80.1-150.4c-4.2-7.9 1.5-17.6 10.6-17.6h65.2c4.6 0 8.8 2.6 10.8 6.7l55.4 113.2c14.5 34.7 27.1 71.9 27.1 71.9h1.3s12.6-37.2 27.1-71.9l55.4-113.2c2-4.1 6.2-6.7 10.8-6.7h65.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/yen-sign.js
// module id = 2119
// module chunks = 0